import {ColDef} from "ag-grid-community";

export enum ReasonCode {
    TFWORK = "TFWORK",
    DDT = "DDT",
    BTF = "BTF"
}

export enum OperationScope {
    ViewMdTransportationCartransporterScope = 'SCOPE_VIEW_MDTRANSPORTATION_CARTRANSPORTER_LABEL'
}

export const EXPIRED_DEFAULT_COL_DEF: ColDef = {
    resizable: true,
    lockPinned: true,
    unSortIcon: true,
    suppressSizeToFit: true
};